import { useState, useEffect } from 'react';

// Version simple de useApi: ne fait que des GET requests

export function useApiGet(endpoint) {
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let isMounted = true;

        const fetchData = async () => {
            try {
                const response = await fetch(endpoint);
                if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
                const json = await response.json();
                if (isMounted) setData(json);
            } catch (err) {
                if (isMounted) setError(err.message);
            } finally {
                if (isMounted) setLoading(false);
            }
        };

        fetchData();

        return () => {
            isMounted = false; // Cleanup if component unmounts
        };
    }, [endpoint]); // pour faire plaisir a React

    return { data, error, loading };
}